import React from 'react';

const ICON_STROKE_COLOR = '#2A353D';

const icons = {
  notAllowedIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.22676 4.22676C4.5291 3.92441 5.01929 3.92441 5.32163 4.22676L12 10.9051L18.6784 4.22676C18.9807 3.92441 19.4709 3.92441 19.7732 4.22676C20.0756 4.5291 20.0756 5.01929 19.7732 5.32163L13.0949 12L19.7732 18.6784C20.0756 18.9807 20.0756 19.4709 19.7732 19.7732C19.4709 20.0756 18.9807 20.0756 18.6784 19.7732L12 13.0949L5.32163 19.7732C5.01929 20.0756 4.5291 20.0756 4.22676 19.7732C3.92441 19.4709 3.92441 18.9807 4.22676 18.6784L10.9051 12L4.22676 5.32163C3.92441 5.01929 3.92441 4.5291 4.22676 4.22676Z"
        fill={ICON_STROKE_COLOR}
      />
    </svg>
  ),
  allowedIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8198 6.19526C20.0601 6.45561 20.0601 6.87772 19.8198 7.13807L9.9736 17.8047C9.73328 18.0651 9.34364 18.0651 9.10332 17.8047L4.18024 12.4714C3.93992 12.2111 3.93992 11.7889 4.18024 11.5286C4.42056 11.2682 4.8102 11.2682 5.05053 11.5286L9.53846 16.3905L18.9495 6.19526C19.1898 5.93491 19.5794 5.93491 19.8198 6.19526Z"
        fill={ICON_STROKE_COLOR}
      />
    </svg>
  ),
  typeIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.99932 22L8.74868 18.4911C8.61394 16.6046 10.108 15 11.9993 15C13.8906 15 15.3847 16.6046 15.25 18.4911L14.9993 22"
        stroke="#2A353D"
        strokeWidth="1.5"
      />
      <path
        d="M2.35139 13.2135C1.99837 10.9162 1.82186 9.76763 2.25617 8.74938C2.69047 7.73112 3.65403 7.03443 5.58114 5.64106L7.02099 4.6C9.41829 2.86667 10.6169 2 12 2C13.3831 2 14.5817 2.86667 16.979 4.6L18.4189 5.64106C20.346 7.03443 21.3095 7.73112 21.7438 8.74938C22.1781 9.76763 22.0016 10.9162 21.6486 13.2135L21.3476 15.1724C20.8471 18.4289 20.5969 20.0572 19.429 21.0286C18.2611 22 16.5537 22 13.1388 22H10.8612C7.44633 22 5.73891 22 4.571 21.0286C3.40309 20.0572 3.15287 18.4289 2.65243 15.1724L2.35139 13.2135Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  ),
  clockIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="#2A353D" fill="none" strokeWidth="1.5" />
      <path
        d="M12 8V12L14 14"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  dollarIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M14 10.1278C14 10.542 14.3358 10.8778 14.75 10.8778C15.1642 10.8778 15.5 10.542 15.5 10.1278H14ZM9.75 13.8726C9.75 13.4584 9.41421 13.1226 9 13.1226C8.58579 13.1226 8.25 13.4584 8.25 13.8726H9.75ZM12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7L12.75 7ZM11.25 17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17H11.25ZM12 11.1062C11.0478 11.1062 10.5431 10.9543 10.2922 10.7864C10.1056 10.6615 10 10.4909 10 10.1278H8.5C8.5 10.8783 8.76936 11.572 9.45777 12.0328C10.0819 12.4507 10.9522 12.6062 12 12.6062V11.1062ZM10 10.1278C10 9.86732 10.1424 9.56819 10.4989 9.30676C10.855 9.04566 11.3833 8.86133 12 8.86133V7.36133C11.0979 7.36133 10.2512 7.6284 9.61196 8.09711C8.97319 8.56549 8.5 9.2746 8.5 10.1278H10ZM12 8.86133C12.6167 8.86133 13.145 9.04566 13.501 9.30676C13.8576 9.56819 14 9.86732 14 10.1278H15.5C15.5 9.27459 15.0268 8.56549 14.388 8.09711C13.7488 7.6284 12.9021 7.36133 12 7.36133V8.86133ZM14.25 13.8726C14.25 14.3084 14.0711 14.5775 13.7369 14.777C13.3572 15.0037 12.7608 15.1391 12 15.1391V16.6391C12.896 16.6391 13.7997 16.4865 14.5057 16.065C15.2573 15.6163 15.75 14.8772 15.75 13.8726H14.25ZM12 15.1391C11.3002 15.1391 10.7004 14.9471 10.2971 14.676C9.88907 14.4018 9.75 14.1036 9.75 13.8726H8.25C8.25 14.7554 8.78251 15.4654 9.46029 15.921C10.1428 16.3797 11.0429 16.6391 12 16.6391V15.1391ZM12 12.6062C12.9582 12.6062 13.5279 12.7501 13.8421 12.9537C14.088 13.1131 14.25 13.354 14.25 13.8726H15.75C15.75 12.951 15.412 12.1837 14.6579 11.6949C13.9721 11.2504 13.0418 11.1062 12 11.1062V12.6062ZM12.75 8.11133L12.75 7L11.25 7L11.25 8.11133L12.75 8.11133ZM11.25 15.8891V17H12.75V15.8891H11.25Z"
        fill="none"
      />
    </svg>
  ),
  fbIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.18182 10.3333C5.20406 10.3333 5 10.5252 5 11.4444V13.1111C5 14.0304 5.20406 14.2222 6.18182 14.2222H8.54545V20.8889C8.54545 21.8081 8.74951 22 9.72727 22H12.0909C13.0687 22 13.2727 21.8081 13.2727 20.8889V14.2222H15.9267C16.6683 14.2222 16.8594 14.0867 17.0631 13.4164L17.5696 11.7497C17.9185 10.6014 17.7035 10.3333 16.4332 10.3333H13.2727V7.55556C13.2727 6.94191 13.8018 6.44444 14.4545 6.44444H17.8182C18.7959 6.44444 19 6.25259 19 5.33333V3.11111C19 2.19185 18.7959 2 17.8182 2H14.4545C11.191 2 8.54545 4.48731 8.54545 7.55556V10.3333H6.18182Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
        strokeLinejoin="round"
      />
    </svg>
  ),
  messengerIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 14L8.9954 11.6055C9.63153 10.8422 9.9496 10.4605 10.3333 10.4605C10.7171 10.4605 11.0351 10.8422 11.6713 11.6055L12.3287 12.3945C12.9649 13.1578 13.2829 13.5395 13.6667 13.5395C14.0504 13.5395 14.3685 13.1578 15.0046 12.3945L17 10"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
        strokeLinejoin="round"
      />
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.3789 2.27907 14.6926 2.78382 15.8877C3.06278 16.5481 3.20226 16.8784 3.21953 17.128C3.2368 17.3776 3.16334 17.6521 3.01642 18.2012L2 22L5.79877 20.9836C6.34788 20.8367 6.62244 20.7632 6.87202 20.7805C7.12161 20.7977 7.45185 20.9372 8.11235 21.2162C9.30745 21.7209 10.6211 22 12 22Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
        strokeLinejoin="round"
      />
    </svg>
  ),
  twitterIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 18.5C3.76504 19.521 5.81428 20 8 20C14.4808 20 19.7617 14.8625 19.9922 8.43797L22 4.5L18.6458 5C17.9407 4.37764 17.0144 4 16 4C13.4276 4 11.5007 6.51734 12.1209 8.98003C8.56784 9.20927 5.34867 7.0213 3.48693 4.10523C2.25147 8.30185 3.39629 13.3561 6.5 16.4705C6.5 17.647 3.5 18.3488 2 18.5Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
        strokeLinejoin="round"
      />
    </svg>
  ),
  copyIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 15C9 12.1716 9 10.7574 9.87868 9.87868C10.7574 9 12.1716 9 15 9L16 9C18.8284 9 20.2426 9 21.1213 9.87868C22 10.7574 22 12.1716 22 15V16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H15C12.1716 22 10.7574 22 9.87868 21.1213C9 20.2426 9 18.8284 9 16L9 15Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9999 9C16.9975 6.04291 16.9528 4.51121 16.092 3.46243C15.9258 3.25989 15.7401 3.07418 15.5376 2.90796C14.4312 2 12.7875 2 9.5 2C6.21252 2 4.56878 2 3.46243 2.90796C3.25989 3.07417 3.07418 3.25989 2.90796 3.46243C2 4.56878 2 6.21252 2 9.5C2 12.7875 2 14.4312 2.90796 15.5376C3.07417 15.7401 3.25989 15.9258 3.46243 16.092C4.51121 16.9528 6.04291 16.9975 9 16.9999"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
        strokeLinejoin="round"
      />
    </svg>
  ),
  emailIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="#2A353D" strokeWidth="1.5" />
      <path
        d="M22 13.2644C21.0732 13.0906 20.12 13 19.1472 13C13.7948 13 9.03435 15.7425 6 20"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
        strokeLinejoin="round"
      />
      <path
        d="M19 5C15.8705 8.66742 11.1679 11 5.90962 11C4.56437 11 3.25548 10.8473 2 10.5587"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
        strokeLinejoin="round"
      />
      <path
        d="M14.6178 22C14.8684 20.786 15 19.5287 15 18.2407C15 11.9247 11.8343 6.34645 7 3"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
        strokeLinejoin="round"
      />
    </svg>
  ),
  reviewIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.7276 3.44418L15.4874 6.99288C15.7274 7.48687 16.3673 7.9607 16.9073 8.05143L20.0969 8.58575C22.1367 8.92853 22.6167 10.4206 21.1468 11.8925L18.6671 14.3927C18.2471 14.8161 18.0172 15.6327 18.1471 16.2175L18.8571 19.3125C19.417 21.7623 18.1271 22.71 15.9774 21.4296L12.9877 19.6452C12.4478 19.3226 11.5579 19.3226 11.0079 19.6452L8.01827 21.4296C5.8785 22.71 4.57865 21.7522 5.13859 19.3125L5.84851 16.2175C5.97849 15.6327 5.74852 14.8161 5.32856 14.3927L2.84884 11.8925C1.389 10.4206 1.85895 8.92853 3.89872 8.58575L7.08837 8.05143C7.61831 7.9607 8.25824 7.48687 8.49821 6.99288L10.258 3.44418C11.2179 1.51861 12.7777 1.51861 13.7276 3.44418Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
        strokeLinejoin="round"
      />
    </svg>
  ),
  identityVerifiedIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9982 2.00009C8.99043 2.00009 7.04018 4.01908 4.73371 4.75499C3.79589 5.05422 3.32697 5.20383 3.1372 5.41474C2.94743 5.62565 2.89186 5.93384 2.78072 6.55023C1.59143 13.1461 4.1909 19.2441 10.3903 21.6176C11.0564 21.8726 11.3894 22.0001 12.0015 22.0001C12.6135 22.0001 12.9466 21.8726 13.6126 21.6176C19.8116 19.244 22.4086 13.1461 21.219 6.55022C21.1078 5.93373 21.0522 5.62549 20.8624 5.41458C20.6726 5.20367 20.2037 5.05414 19.2659 4.75508C16.9585 4.01924 15.0061 2.00009 11.9982 2.00009Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
        strokeLinejoin="round"
      />
      <path d="M12 7.00009L12 9.00009" stroke="#2A353D" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  contact: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="4"
        y="2"
        width="17.5"
        height="20"
        rx="4"
        stroke={ICON_STROKE_COLOR}
        fill="none"
        strokeWidth="1.5"
      />
      <path
        d="M10.59 13.7408C9.96125 14.162 8.31261 15.0221 9.31674 16.0983C9.80725 16.624 10.3536 17 11.0404 17H14.9596C15.6464 17 16.1928 16.624 16.6833 16.0983C17.6874 15.0221 16.0388 14.162 15.41 13.7408C13.9355 12.7531 12.0645 12.7531 10.59 13.7408Z"
        stroke={ICON_STROKE_COLOR}
        fill="none"
        strokeWidth="1.5"
      />
      <path
        d="M15 9C15 10.1046 14.1046 11 13 11C11.8954 11 11 10.1046 11 9C11 7.89543 11.8954 7 13 7C14.1046 7 15 7.89543 15 9Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
      />
      <path
        d="M5 6L2.5 6M5 12L2.5 12M5 18H2.5"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
        strokeLinejoin="round"
      />
    </svg>
  ),
  password: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9982 2.00009C8.99043 2.00009 7.04018 4.01908 4.73371 4.75499C3.79589 5.05422 3.32697 5.20383 3.1372 5.41474C2.94743 5.62565 2.89186 5.93384 2.78072 6.55023C1.59143 13.1461 4.1909 19.2441 10.3903 21.6176C11.0564 21.8726 11.3894 22.0001 12.0015 22.0001C12.6135 22.0001 12.9466 21.8726 13.6126 21.6176C19.8116 19.244 22.4086 13.1461 21.219 6.55022C21.1078 5.93373 21.0522 5.62549 20.8624 5.41458C20.6726 5.20367 20.2037 5.05414 19.2659 4.75508C16.9585 4.01924 15.0061 2.00009 11.9982 2.00009Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7.00009L12 9.00009"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  card: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 12C2 8.46252 2 6.69377 3.0528 5.5129C3.22119 5.32403 3.40678 5.14935 3.60746 4.99087C4.86213 4 6.74142 4 10.5 4H13.5C17.2586 4 19.1379 4 20.3925 4.99087C20.5932 5.14935 20.7788 5.32403 20.9472 5.5129C22 6.69377 22 8.46252 22 12C22 15.5375 22 17.3062 20.9472 18.4871C20.7788 18.676 20.5932 18.8506 20.3925 19.0091C19.1379 20 17.2586 20 13.5 20H10.5C6.74142 20 4.86213 20 3.60746 19.0091C3.40678 18.8506 3.22119 18.676 3.0528 18.4871C2 17.3062 2 15.5375 2 12Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 16H11.5"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 16L18 16"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2 9H22" stroke={ICON_STROKE_COLOR} strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  ),
  paypal: (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M5.50971 2.90194C5.55646 2.66823 5.76166 2.5 6 2.5H14.2602C16.4993 2.5 18.1625 4.57346 17.6768 6.75926L17.0101 9.75926C16.6543 11.3606 15.2339 12.5 13.5935 12.5H9.89039L8.48508 18.1213C8.42943 18.3439 8.22944 18.5 8 18.5H3C2.85021 18.5 2.7083 18.4328 2.61333 18.317C2.51836 18.2012 2.48034 18.0488 2.50971 17.9019L5.50971 2.90194ZM6.40991 3.5L3.60991 17.5H7.60962L9.01493 11.8787C9.07058 11.6561 9.27057 11.5 9.5 11.5H13.5935C14.7652 11.5 15.7798 10.6862 16.034 9.54233L16.7006 6.54233C17.0476 4.98104 15.8595 3.5 14.2602 3.5H6.40991Z"
        fill="black"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M17.2602 6.5H17V5.5H17.2602C19.4993 5.5 21.1625 7.57346 20.6768 9.75926L20.0101 12.7593C19.6543 14.3606 18.2339 15.5 16.5935 15.5H12.8904L11.4851 21.1213C11.4294 21.3439 11.2294 21.5 11 21.5H6C5.85021 21.5 5.7083 21.4328 5.61333 21.317C5.51836 21.2012 5.48034 21.0488 5.50971 20.9019L6.10971 17.9019L7.09029 18.0981L6.60991 20.5H10.6096L12.0149 14.8787C12.0706 14.6561 12.2706 14.5 12.5 14.5H16.5935C17.7652 14.5 18.7798 13.6862 19.034 12.5423L19.7006 9.54233C20.0476 7.98104 18.8595 6.5 17.2602 6.5Z"
        fill="black"
        fillRule="evenodd"
      />
    </svg>
  ),
  payout: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 14C16 14.8284 16.6716 15.5 17.5 15.5C18.3284 15.5 19 14.8284 19 14C19 13.1716 18.3284 12.5 17.5 12.5C16.6716 12.5 16 13.1716 16 14Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
      />
      <path
        d="M10 7H16C18.8284 7 20.2426 7 21.1213 7.87868C22 8.75736 22 10.1716 22 13V15C22 17.8284 22 19.2426 21.1213 20.1213C20.2426 21 18.8284 21 16 21H10C6.22876 21 4.34315 21 3.17157 19.8284C2 18.6569 2 16.7712 2 13V11C2 7.22876 2 5.34315 3.17157 4.17157C4.34315 3 6.22876 3 10 3H14C14.93 3 15.395 3 15.7765 3.10222C16.8117 3.37962 17.6204 4.18827 17.8978 5.22354C18 5.60504 18 6.07003 18 7"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  listings: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="1.5"
        cy="1.5"
        r="1.5"
        transform="matrix(1 0 0 -1 16 8.00024)"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.77423 11.1439C1.77108 12.2643 1.7495 13.9546 2.67016 15.1437C4.49711 17.5033 6.49674 19.5029 8.85633 21.3298C10.0454 22.2505 11.7357 22.2289 12.8561 21.2258C15.8979 18.5022 18.6835 15.6559 21.3719 12.5279C21.6377 12.2187 21.8039 11.8397 21.8412 11.4336C22.0062 9.63798 22.3452 4.46467 20.9403 3.05974C19.5353 1.65481 14.362 1.99377 12.5664 2.15876C12.1603 2.19608 11.7813 2.36233 11.472 2.62811C8.34412 5.31646 5.49781 8.10211 2.77423 11.1439Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
      />
      <path
        d="M7 14.0002L10 17.0002"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  upArrow: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 15L11.2929 9.70711C11.6262 9.37377 11.7929 9.20711 12 9.20711C12.2071 9.20711 12.3738 9.37377 12.7071 9.70711L18 15"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  downArrow: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 9L11.2929 14.2929C11.6262 14.6262 11.7929 14.7929 12 14.7929C12.2071 14.7929 12.3738 14.6262 12.7071 14.2929L18 9"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  profile: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
      />
      <circle cx="16.5" cy="7.5" r="1.5" stroke={ICON_STROKE_COLOR} strokeWidth="1.5" />
      <path
        d="M2 14.1354C2.66663 14.0455 3.3406 14.0011 4.01569 14.0027C6.87163 13.9466 9.65761 14.7729 11.8765 16.3342C13.9345 17.7821 15.3805 19.7749 16 22"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M13 18C14.7015 16.6733 16.5345 15.9928 18.3862 16.0001C19.4362 15.999 20.4812 16.2216 21.5 16.6617"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  ),
  dashboard: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="8" height="10" rx="2" stroke={ICON_STROKE_COLOR} strokeWidth="1.5" />
      <rect x="2" y="16" width="8" height="6" rx="2" stroke={ICON_STROKE_COLOR} strokeWidth="1.5" />
      <rect
        x="14"
        y="12"
        width="8"
        height="10"
        rx="2"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
      />
      <rect x="14" y="2" width="8" height="6" rx="2" stroke={ICON_STROKE_COLOR} strokeWidth="1.5" />
    </svg>
  ),
  close: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.22676 4.22676C4.5291 3.92441 5.01929 3.92441 5.32163 4.22676L12 10.9051L18.6784 4.22676C18.9807 3.92441 19.4709 3.92441 19.7732 4.22676C20.0756 4.5291 20.0756 5.01929 19.7732 5.32163L13.0949 12L19.7732 18.6784C20.0756 18.9807 20.0756 19.4709 19.7732 19.7732C19.4709 20.0756 18.9807 20.0756 18.6784 19.7732L12 13.0949L5.32163 19.7732C5.01929 20.0756 4.5291 20.0756 4.22676 19.7732C3.92441 19.4709 3.92441 18.9807 4.22676 18.6784L10.9051 12L4.22676 5.32163C3.92441 5.01929 3.92441 4.5291 4.22676 4.22676Z"
        fill="#030D45"
      />
    </svg>
  ),
  shipping: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17" cy="18" r="2" stroke={ICON_STROKE_COLOR} strokeWidth="1.5" />
      <circle cx="7" cy="18" r="2" stroke={ICON_STROKE_COLOR} strokeWidth="1.5" />
      <path
        d="M5 17.9724C3.90328 17.9178 3.2191 17.7546 2.73223 17.2678C2.24536 16.7809 2.08222 16.0967 2.02755 15M9 18H15M19 17.9724C20.0967 17.9178 20.7809 17.7546 21.2678 17.2678C22 16.5355 22 15.357 22 13V11H17.3C16.5555 11 16.1832 11 15.882 10.9021C15.2731 10.7043 14.7957 10.2269 14.5979 9.61803C14.5 9.31677 14.5 8.94451 14.5 8.2C14.5 7.08323 14.5 6.52485 14.3532 6.07295C14.0564 5.15964 13.3404 4.44358 12.4271 4.14683C11.9752 4 11.4168 4 10.3 4H2"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 8H8"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 11H6"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 6H16.3212C17.7766 6 18.5042 6 19.0964 6.35371C19.6886 6.70742 20.0336 7.34811 20.7236 8.6295L22 11"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  info: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.53846C7.32682 3.53846 3.53846 7.32682 3.53846 12C3.53846 16.6732 7.32682 20.4615 12 20.4615C16.6732 20.4615 20.4615 16.6732 20.4615 12C20.4615 7.32682 16.6732 3.53846 12 3.53846ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
        fill="#030D45"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 8.15385C11.2919 8.15385 10.7179 8.72784 10.7179 9.4359C10.7179 9.86073 10.3736 10.2051 9.94872 10.2051C9.52388 10.2051 9.17949 9.86073 9.17949 9.4359C9.17949 7.87817 10.4423 6.61539 12 6.61539C13.5577 6.61539 14.8205 7.87817 14.8205 9.4359C14.8205 9.99624 14.6563 10.5206 14.3731 10.9606C14.1958 11.2363 13.9884 11.4994 13.7972 11.7371C13.7622 11.7805 13.7279 11.8231 13.6941 11.8649C13.5355 12.0612 13.3898 12.2415 13.2553 12.4264C12.9234 12.8826 12.7692 13.2253 12.7692 13.5385C12.7692 13.9633 12.4248 14.3077 12 14.3077C11.5752 14.3077 11.2308 13.9633 11.2308 13.5385C11.2308 12.7187 11.6332 12.0408 12.0112 11.5213C12.171 11.3018 12.346 11.0853 12.5051 10.8884C12.537 10.849 12.5683 10.8103 12.5986 10.7726C12.7885 10.5365 12.9502 10.3289 13.0794 10.1282C13.2076 9.92891 13.2821 9.69227 13.2821 9.4359C13.2821 8.72784 12.7081 8.15385 12 8.15385Z"
        fill="#030D45"
      />
      <path
        d="M13.0256 16.6154C13.0256 17.1818 12.5664 17.641 12 17.641C11.4336 17.641 10.9744 17.1818 10.9744 16.6154C10.9744 16.0489 11.4336 15.5897 12 15.5897C12.5664 15.5897 13.0256 16.0489 13.0256 16.6154Z"
        fill="#030D45"
      />
    </svg>
  ),
  trackingPlane: (
    <svg fill="#000000" height="15px" width="20px" version="1.1" id="Layer_1" viewBox="0 0 128 128">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M56.1,11.2c0-9.1,13.8-9.1,13.8,0.3v38.3L123.4,82v14.1L70.1,78.6v28.6l12.3,9.7V128l-19-5.9l-19,5.9v-11.2l12.2-9.7V78.6 L3.2,96.1V82l52.8-32.2V11.2z"></path>
      </g>
    </svg>
  ),
  orderIssues: (
    <svg
      width={24}
      height={16}
      fill="#000000"
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M960 1242.342c62.23 0 112.941 50.71 112.941 112.94 0 62.231-50.71 112.942-112.941 112.942-62.23 0-112.941-50.71-112.941-112.941 0-62.23 50.71-112.941 112.941-112.941Zm89.336-892.01c114.862 29.704 208.264 123.106 237.968 237.967 23.378 90.466 10.729 183.304-35.464 261.46-45.515 77.138-121.186 133.947-207.586 156.084-13.779 3.614-27.783 14.795-27.783 31.962v91.595H903.529v-91.595c0-66.183 46.306-124.235 112.716-141.29 57.6-14.795 107.971-52.743 138.353-104.131 30.833-52.292 39.19-114.635 23.378-175.85-19.651-75.67-81.204-137.223-156.875-156.875-70.927-18.183-143.435-3.953-199.341 39.304-55.68 43.143-87.642 108.31-87.642 178.673H621.176c0-105.6 47.888-203.294 131.464-268.01 83.69-64.828 191.774-86.287 296.696-59.294ZM960-.01c-529.355 0-960 430.644-960 960 0 529.355 430.645 960 960 960 529.468 0 960-430.645 960-960 0-529.356-430.532-960-960-960"
          fillRule="evenodd"
        ></path>
      </g>
    </svg>
  ),
  deliveryInfo: (
    <svg
      width={24}
      height={16}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <rect x="0" fill="none" width="24" height="24"></rect>
        <g>
          <path d="M18 8h-2V7c0-1.105-.895-2-2-2H4c-1.105 0-2 .895-2 2v10h2c0 1.657 1.343 3 3 3s3-1.343 3-3h4c0 1.657 1.343 3 3 3s3-1.343 3-3h2v-5l-4-4zM7 18.5c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5 1.5.672 1.5 1.5-.672 1.5-1.5 1.5zM4 14V7h10v7H4zm13 4.5c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5 1.5.672 1.5 1.5-.672 1.5-1.5 1.5z"></path>
        </g>
      </g>
    </svg>
  ),
  checkmark: (
    <svg
      fill="#000000"
      viewBox="0 0 32 32"
      width={20}
      height={20}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <title>checkmark</title>
        <path
          fill="#3ac200"
          d="M16 3c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zM23.258 12.307l-9.486 9.485c-0.238 0.237-0.623 0.237-0.861 0l-0.191-0.191-0.001 0.001-5.219-5.256c-0.238-0.238-0.238-0.624 0-0.862l1.294-1.293c0.238-0.238 0.624-0.238 0.862 0l3.689 3.716 7.756-7.756c0.238-0.238 0.624-0.238 0.862 0l1.294 1.294c0.239 0.237 0.239 0.623 0.001 0.862z"
        ></path>
      </g>
    </svg>
  ),
  checkmarkLarge: (
    <svg
      fill="#000000"
      viewBox="0 0 32 32"
      width={32}
      height={32}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <title>checkmark</title>
        <path
          fill="#3ac200"
          d="M16 3c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zM23.258 12.307l-9.486 9.485c-0.238 0.237-0.623 0.237-0.861 0l-0.191-0.191-0.001 0.001-5.219-5.256c-0.238-0.238-0.238-0.624 0-0.862l1.294-1.293c0.238-0.238 0.624-0.238 0.862 0l3.689 3.716 7.756-7.756c0.238-0.238 0.624-0.238 0.862 0l1.294 1.294c0.239 0.237 0.239 0.623 0.001 0.862z"
        ></path>
      </g>
    </svg>
  ),
  backIcon: (
    <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.40388 8.20006L7.68063 2.67289C7.78898 2.57257 7.87392 2.44758 7.92892 2.30754C7.98392 2.16749 8.00752 2.01612 7.99791 1.86504C7.98829 1.71396 7.94572 1.56719 7.87347 1.43602C7.80121 1.30485 7.70119 1.19276 7.58109 1.10836C7.38115 0.956741 7.13643 0.884033 6.89021 0.903102C6.644 0.922172 6.41216 1.03179 6.23573 1.21256L0.306793 7.4699C0.210103 7.5627 0.132902 7.67554 0.0800877 7.80123C0.0272732 7.92693 0 8.06275 0 8.20006C0 8.33738 0.0272732 8.4732 0.0800877 8.59889C0.132902 8.72459 0.210103 8.83742 0.306793 8.93023L6.23573 15.1876C6.41216 15.3683 6.644 15.478 6.89021 15.497C7.13643 15.5161 7.38115 15.4434 7.58109 15.2918C7.70119 15.2074 7.80121 15.0953 7.87347 14.9641C7.94572 14.8329 7.98829 14.6862 7.99791 14.5351C8.00752 14.384 7.98392 14.2326 7.92892 14.0926C7.87392 13.9525 7.78898 13.8276 7.68063 13.7272L2.40388 8.20006Z"
        fill="#000"
      />
    </svg>
  ),
  dashboardHome: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 17C14.2005 17.6224 13.1502 18 12 18C10.8498 18 9.79952 17.6224 9 17"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.35139 13.2135C1.99837 10.9162 1.82186 9.76763 2.25617 8.74938C2.69047 7.73112 3.65403 7.03443 5.58114 5.64106L7.02099 4.6C9.41829 2.86667 10.6169 2 12 2C13.3831 2 14.5817 2.86667 16.979 4.6L18.4189 5.64106C20.346 7.03443 21.3095 7.73112 21.7438 8.74938C22.1781 9.76763 22.0016 10.9162 21.6486 13.2135L21.3476 15.1724C20.8471 18.4289 20.5969 20.0572 19.429 21.0286C18.2611 22 16.5537 22 13.1388 22H10.8612C7.44633 22 5.73891 22 4.571 21.0286C3.40309 20.0572 3.15287 18.4289 2.65243 15.1724L2.35139 13.2135Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  ),
  dashboardPayouts: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 14C16 14.8284 16.6716 15.5 17.5 15.5C18.3284 15.5 19 14.8284 19 14C19 13.1716 18.3284 12.5 17.5 12.5C16.6716 12.5 16 13.1716 16 14Z"
        stroke="#2A353D"
        strokeWidth="1.5"
      />
      <path
        d="M10 7H16C18.8284 7 20.2426 7 21.1213 7.87868C22 8.75736 22 10.1716 22 13V15C22 17.8284 22 19.2426 21.1213 20.1213C20.2426 21 18.8284 21 16 21H10C6.22876 21 4.34315 21 3.17157 19.8284C2 18.6569 2 16.7712 2 13V11C2 7.22876 2 5.34315 3.17157 4.17157C4.34315 3 6.22876 3 10 3H14C14.93 3 15.395 3 15.7765 3.10222C16.8117 3.37962 17.6204 4.18827 17.8978 5.22354C18 5.60504 18 6.07003 18 7"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  dashboardInbox: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 18.6458V8.05426C4 5.20025 4 3.77325 4.87868 2.88663C5.75736 2 7.17157 2 10 2H14C16.8284 2 18.2426 2 19.1213 2.88663C20 3.77325 20 5.20025 20 8.05426V18.6458C20 20.1575 20 20.9133 19.538 21.2108C18.7831 21.6971 17.6161 20.6774 17.0291 20.3073C16.5441 20.0014 16.3017 19.8485 16.0325 19.8397C15.7417 19.8301 15.4949 19.9768 14.9709 20.3073L13.06 21.5124C12.5445 21.8374 12.2868 22 12 22C11.7132 22 11.4555 21.8374 10.94 21.5124L9.02913 20.3073C8.54415 20.0014 8.30166 19.8485 8.03253 19.8397C7.74172 19.8301 7.49493 19.9768 6.97087 20.3073C6.38395 20.6774 5.21687 21.6971 4.46195 21.2108C4 20.9133 4 20.1575 4 18.6458Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 11H8"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 7L8 7"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  offerIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.46433 9.34375C2.21579 9.34375 1.98899 9.14229 2.00041 8.87895C2.06733 7.33687 2.25481 6.33298 2.78008 5.53884C3.08228 5.08196 3.45765 4.68459 3.88923 4.36468C5.05575 3.5 6.70139 3.5 9.99266 3.5H14.0074C17.2986 3.5 18.9443 3.5 20.1108 4.36468C20.5424 4.68459 20.9177 5.08196 21.2199 5.53884C21.7452 6.33289 21.9327 7.33665 21.9996 8.87843C22.011 9.14208 21.7839 9.34375 21.5351 9.34375C20.1493 9.34375 19.0259 10.533 19.0259 12C19.0259 13.467 20.1493 14.6562 21.5351 14.6562C21.7839 14.6562 22.011 14.8579 21.9996 15.1216C21.9327 16.6634 21.7452 17.6671 21.2199 18.4612C20.9177 18.918 20.5424 19.3154 20.1108 19.6353C18.9443 20.5 17.2986 20.5 14.0074 20.5H9.99266C6.70139 20.5 5.05575 20.5 3.88923 19.6353C3.45765 19.3154 3.08228 18.918 2.78008 18.4612C2.25481 17.667 2.06733 16.6631 2.00041 15.1211C1.98899 14.8577 2.21579 14.6562 2.46433 14.6562C3.85012 14.6562 4.97352 13.467 4.97352 12C4.97352 10.533 3.85012 9.34375 2.46433 9.34375Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 14.5L14.5 9.5"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 9.5H9.51122M14.4888 14.5H14.5"
        stroke="#2A353D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  tabRibbon: (
    <svg
      width="800"
      height="780"
      viewBox="0 0 800 780"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.24"
        d="M310.539 676.953C301.636 670.931 290.795 667.378 279.269 667.392C271.58 667.392 264.177 668.954 257.483 671.798C247.43 676.05 238.928 683.117 232.894 692.045C226.86 700.948 223.319 711.789 223.344 723.314C223.331 730.989 224.895 738.393 227.738 745.086C232 755.153 239.056 763.654 247.972 769.675C256.888 775.723 267.741 779.25 279.267 779.25C286.942 779.25 294.335 777.686 301.027 774.843C311.092 770.592 319.594 763.511 325.63 754.597C331.652 745.693 335.192 734.839 335.192 723.312C335.192 715.639 333.616 708.247 330.786 701.54C326.524 691.476 319.455 682.975 310.539 676.953ZM300.047 732.089C298.341 736.12 295.46 739.597 291.855 742.025C288.236 744.454 283.999 745.862 279.269 745.875C276.103 745.862 273.171 745.242 270.496 744.09C266.477 742.412 262.988 739.517 260.558 735.925C258.128 732.293 256.72 728.043 256.708 723.312C256.722 720.159 257.353 717.239 258.478 714.539C260.17 710.52 263.066 707.045 266.669 704.604C270.288 702.175 274.539 700.779 279.269 700.765C282.422 700.765 285.342 701.4 288.03 702.536C292.061 704.228 295.524 707.109 297.953 710.728C300.396 714.345 301.803 718.584 301.803 723.312C301.803 726.481 301.172 729.401 300.047 732.089Z"
        fill="black"
      />
      <path
        opacity="0.24"
        d="M338.321 433.076C349.692 429.768 356.23 417.842 352.896 406.457L297.308 216.151C294 204.767 282.086 198.242 270.702 201.562C259.319 204.884 252.806 216.797 256.114 228.168L311.702 418.5C315.035 429.872 326.949 436.409 338.321 433.076Z"
        fill="black"
      />
      <path
        opacity="0.24"
        d="M401.531 404.339C404.866 415.723 416.78 422.248 428.149 418.926C439.521 415.606 446.06 403.693 442.725 392.309L391.169 215.79C387.861 204.407 375.947 197.881 364.564 201.19C353.18 204.523 346.655 216.437 349.975 227.807L401.531 404.339Z"
        fill="black"
      />
      <path
        opacity="0.24"
        d="M491.491 390.603C494.811 401.987 506.738 408.512 518.108 405.192C529.48 401.87 536.017 389.943 532.683 378.573L485.042 215.429C481.721 204.045 469.808 197.52 458.436 200.854C447.053 204.162 440.527 216.089 443.849 227.459L491.491 390.603Z"
        fill="black"
      />
      <path
        opacity="0.24"
        d="M581.164 375.951C584.499 387.336 596.411 393.861 607.781 390.539C619.153 387.206 625.691 375.306 622.37 363.922L578.889 215.054C575.581 203.672 563.655 197.159 552.271 200.467C540.9 203.801 534.375 215.714 537.696 227.084L581.164 375.951Z"
        fill="black"
      />
      <path
        opacity="0.24"
        d="M263.635 603.445C257.586 603.445 251.928 602.229 246.733 600.045C238.967 596.764 232.286 591.233 227.61 584.281C223.113 577.6 220.45 569.731 220.244 561.1C220.475 550.8 223.758 541.861 229.521 534.714C232.505 531.031 236.188 527.801 240.658 525.126C245.077 522.49 250.285 520.397 256.397 519.079L638.17 456.94C663.11 452.87 682.956 433.8 687.995 409.028L734.694 179.453V179.428C735.236 176.765 735.496 174.053 735.496 171.365C735.496 162.087 732.316 153.017 726.347 145.703C718.644 136.297 707.119 130.831 694.96 130.831H166.335L148.325 68.9528V68.9653C140.055 41.3012 117.366 20.3434 89.1455 14.2965L24.5127 0.455903C13.5799 -1.89566 2.8049 5.08246 0.451773 16.0262C-1.88573 26.97 5.07677 37.7465 16.0361 40.0856L80.6424 53.9372C94.3893 56.8825 105.452 67.0903 109.483 80.5809L227.583 486.259C224.922 487.5 222.35 488.843 219.869 490.329C207.141 497.915 196.933 508.562 190.086 520.992C183.533 532.801 180.058 546.189 179.724 560.001H179.672V562.107H179.724C179.981 572.898 182.281 583.247 186.274 592.693C192.671 607.798 203.291 620.578 216.677 629.622C230.052 638.678 246.319 643.99 263.633 643.976H478.121C478.055 641.975 477.817 640.023 477.817 638.007C477.817 626.184 479.038 614.645 481.214 603.443H263.635V603.445ZM178.122 171.367H694.963H694.977L648.278 400.953C646.597 409.223 639.981 415.581 631.661 416.925L266.891 476.311L178.122 171.367Z"
        fill="black"
      />
      <path
        d="M658.756 496.765C580.75 496.765 517.513 560.003 517.513 638.009C517.513 716.015 580.75 779.253 658.756 779.253C736.775 779.253 800 716.015 800 638.009C800 560.003 736.775 496.765 658.756 496.765Z"
        fill="#C6488C"
      />
      <path
        d="M694.484 638.539L734.099 597.31L700.147 564.687L660.532 605.917L619.302 566.301L586.687 600.245L627.918 639.861L588.302 681.091L622.254 713.713L661.869 672.483L703.09 712.089L735.704 678.145L694.484 638.539Z"
        fill="white"
      />
    </svg>
  ),
  clock: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="#f77f00" strokeWidth="1.5" />
      <path
        d="M12 8V12L14 14"
        stroke="#f77f00"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  expiredClock: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="#ED1B24" strokeWidth="1.5" />
      <path
        d="M11.992 15H12.001"
        stroke="#ED1B24"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12L12 8"
        stroke="#ED1B24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  emptyInbox: (
    <svg
      width="800"
      height="780"
      viewBox="0 0 800 780"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.24"
        d="M310.539 676.953C301.636 670.931 290.795 667.378 279.269 667.392C271.58 667.392 264.177 668.954 257.483 671.798C247.43 676.05 238.928 683.117 232.894 692.045C226.86 700.948 223.319 711.789 223.344 723.314C223.331 730.989 224.895 738.393 227.738 745.086C232 755.153 239.056 763.654 247.972 769.675C256.888 775.723 267.741 779.25 279.267 779.25C286.942 779.25 294.335 777.686 301.027 774.843C311.092 770.592 319.594 763.511 325.63 754.597C331.652 745.693 335.192 734.839 335.192 723.312C335.192 715.639 333.616 708.247 330.786 701.54C326.524 691.476 319.455 682.975 310.539 676.953ZM300.047 732.089C298.341 736.12 295.46 739.597 291.855 742.025C288.236 744.454 283.999 745.862 279.269 745.875C276.103 745.862 273.171 745.242 270.496 744.09C266.477 742.412 262.988 739.517 260.558 735.925C258.128 732.293 256.72 728.043 256.708 723.312C256.722 720.159 257.353 717.239 258.478 714.539C260.17 710.52 263.066 707.045 266.669 704.604C270.288 702.175 274.539 700.779 279.269 700.765C282.422 700.765 285.342 701.4 288.03 702.536C292.061 704.228 295.524 707.109 297.953 710.728C300.396 714.345 301.803 718.584 301.803 723.312C301.803 726.481 301.172 729.401 300.047 732.089Z"
        fill="black"
      />
      <path
        opacity="0.24"
        d="M338.321 433.076C349.692 429.768 356.23 417.842 352.896 406.457L297.308 216.151C294 204.767 282.086 198.242 270.702 201.562C259.319 204.884 252.806 216.797 256.114 228.168L311.702 418.5C315.035 429.872 326.949 436.409 338.321 433.076Z"
        fill="black"
      />
      <path
        opacity="0.24"
        d="M401.531 404.339C404.866 415.723 416.78 422.248 428.149 418.926C439.521 415.606 446.06 403.693 442.725 392.309L391.169 215.79C387.861 204.407 375.947 197.881 364.564 201.19C353.18 204.523 346.655 216.437 349.975 227.807L401.531 404.339Z"
        fill="black"
      />
      <path
        opacity="0.24"
        d="M491.491 390.603C494.811 401.987 506.738 408.512 518.108 405.192C529.48 401.87 536.017 389.943 532.683 378.573L485.042 215.429C481.721 204.045 469.808 197.52 458.436 200.854C447.053 204.162 440.527 216.089 443.849 227.459L491.491 390.603Z"
        fill="black"
      />
      <path
        opacity="0.24"
        d="M581.164 375.951C584.499 387.336 596.411 393.861 607.781 390.539C619.153 387.206 625.691 375.306 622.37 363.922L578.889 215.054C575.581 203.672 563.655 197.159 552.271 200.467C540.9 203.801 534.375 215.714 537.696 227.084L581.164 375.951Z"
        fill="black"
      />
      <path
        opacity="0.24"
        d="M263.635 603.445C257.586 603.445 251.928 602.229 246.733 600.045C238.967 596.764 232.286 591.233 227.61 584.281C223.113 577.6 220.45 569.731 220.244 561.1C220.475 550.8 223.758 541.861 229.521 534.714C232.505 531.031 236.188 527.801 240.658 525.126C245.077 522.49 250.285 520.397 256.397 519.079L638.17 456.94C663.11 452.87 682.956 433.8 687.995 409.028L734.694 179.453V179.428C735.236 176.765 735.496 174.053 735.496 171.365C735.496 162.087 732.316 153.017 726.347 145.703C718.644 136.297 707.119 130.831 694.96 130.831H166.335L148.325 68.9528V68.9653C140.055 41.3012 117.366 20.3434 89.1455 14.2965L24.5127 0.455903C13.5799 -1.89566 2.8049 5.08246 0.451773 16.0262C-1.88573 26.97 5.07677 37.7465 16.0361 40.0856L80.6424 53.9372C94.3893 56.8825 105.452 67.0903 109.483 80.5809L227.583 486.259C224.922 487.5 222.35 488.843 219.869 490.329C207.141 497.915 196.933 508.562 190.086 520.992C183.533 532.801 180.058 546.189 179.724 560.001H179.672V562.107H179.724C179.981 572.898 182.281 583.247 186.274 592.693C192.671 607.798 203.291 620.578 216.677 629.622C230.052 638.678 246.319 643.99 263.633 643.976H478.121C478.055 641.975 477.817 640.023 477.817 638.007C477.817 626.184 479.038 614.645 481.214 603.443H263.635V603.445ZM178.122 171.367H694.963H694.977L648.278 400.953C646.597 409.223 639.981 415.581 631.661 416.925L266.891 476.311L178.122 171.367Z"
        fill="black"
      />
      <path
        d="M658.756 496.765C580.75 496.765 517.513 560.003 517.513 638.009C517.513 716.015 580.75 779.253 658.756 779.253C736.775 779.253 800 716.015 800 638.009C800 560.003 736.775 496.765 658.756 496.765Z"
        fill="#C6488C"
      />
      <path
        d="M694.484 638.539L734.099 597.31L700.147 564.687L660.532 605.917L619.302 566.301L586.687 600.245L627.918 639.861L588.302 681.091L622.254 713.713L661.869 672.483L703.09 712.089L735.704 678.145L694.484 638.539Z"
        fill="white"
      />
    </svg>
  ),
  addIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 4V20"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12H20"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  subtractIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 12L4 12"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  disabledAddIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 4V20"
        stroke="#dedede"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12H20"
        stroke="#dedede"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  disabledSubtractIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 12L4 12"
        stroke="#dedede"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  trip: (
    <svg
      width="20"
      height="20"
      version="1.1"
      id="Icons"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fill="#2A353D"
          d="M28,13h1c0.6,0,1-0.4,1-1s-0.4-1-1-1h-2.8L25,8c-0.8-1.8-2.6-3-4.6-3h-8.7C9.6,5,7.8,6.2,7,8l-1.3,3H3c-0.6,0-1,0.4-1,1 s0.4,1,1,1h1c-1.2,0.9-2,2.4-2,4v4c0,0.9,0.4,1.7,1,2.2V25c0,1.7,1.3,3,3,3h2c1.7,0,3-1.3,3-3v-1h10v1c0,1.7,1.3,3,3,3h2 c1.7,0,3-1.3,3-3v-1.8c0.6-0.5,1-1.3,1-2.2v-4C30,15.4,29.2,13.9,28,13z M27,18c0,0.6-0.4,1-1,1h-3c-0.6,0-1-0.4-1-1s0.4-1,1-1h3 C26.6,17,27,17.4,27,18z M6,17h3c0.6,0,1,0.4,1,1s-0.4,1-1,1H6c-0.6,0-1-0.4-1-1S5.4,17,6,17z M10.4,22l1.2-2.3 c0.5-1,1.5-1.7,2.7-1.7h3.5c1.1,0,2.2,0.6,2.7,1.7l1.2,2.3H10.4z M8.9,8.8C9.4,7.7,10.4,7,11.6,7h8.7c1.2,0,2.3,0.7,2.8,1.8l1.4,3.2 h-17L8.9,8.8z"
        ></path>
      </g>
    </svg>
  ),
  property: (
    <svg
      width="20"
      height="20"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <g>
            <path
              fill="#2A353D"
              d="M489.739,478.609h-50.087V33.391h16.696c9.22,0,16.696-7.475,16.696-16.696S465.568,0,456.348,0 C423.738,0,70.79,0,55.652,0c-9.22,0-16.696,7.475-16.696,16.696s7.475,16.696,16.696,16.696h16.696v445.217H22.261 c-9.22,0-16.696,7.475-16.696,16.696S13.04,512,22.261,512c10.133,0,425.466,0,467.478,0c9.22,0,16.696-7.475,16.696-16.696 S498.96,478.609,489.739,478.609z M406.261,478.609H105.739V33.391h300.522V478.609z"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              fill="#2A353D"
              d="M222.609,77.913h-66.783c-9.22,0-16.696,7.475-16.696,16.696v66.783c0,9.22,7.475,16.696,16.696,16.696h66.783 c9.22,0,16.696-7.475,16.696-16.696V94.609C239.304,85.388,231.829,77.913,222.609,77.913z M205.913,144.696h-33.391v-33.391 h33.391V144.696z"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              fill="#2A353D"
              d="M356.174,77.913h-66.783c-9.22,0-16.696,7.475-16.696,16.696v66.783c0,9.22,7.475,16.696,16.696,16.696h66.783 c9.22,0,16.696-7.475,16.696-16.696V94.609C372.87,85.388,365.394,77.913,356.174,77.913z M339.478,144.696h-33.391v-33.391 h33.391V144.696z"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              fill="#2A353D"
              d="M222.609,211.478h-66.783c-9.22,0-16.696,7.475-16.696,16.696v66.783c0,9.22,7.475,16.696,16.696,16.696h66.783 c9.22,0,16.696-7.475,16.696-16.696v-66.783C239.304,218.953,231.829,211.478,222.609,211.478z M205.913,278.261h-33.391V244.87 h33.391V278.261z"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              fill="#2A353D"
              d="M356.174,211.478h-66.783c-9.22,0-16.696,7.475-16.696,16.696v66.783c0,9.22,7.475,16.696,16.696,16.696h66.783 c9.22,0,16.696-7.475,16.696-16.696v-66.783C372.87,218.953,365.394,211.478,356.174,211.478z M339.478,278.261h-33.391V244.87 h33.391V278.261z"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              fill="#2A353D"
              d="M222.609,345.043h-66.783c-9.22,0-16.696,7.475-16.696,16.696v66.783c0,9.22,7.475,16.696,16.696,16.696h66.783 c9.22,0,16.696-7.475,16.696-16.696v-66.783C239.304,352.519,231.829,345.043,222.609,345.043z M205.913,411.826h-33.391v-33.391 h33.391V411.826z"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              fill="#2A353D"
              d="M356.174,345.043h-66.783c-9.22,0-16.696,7.475-16.696,16.696v66.783c0,9.22,7.475,16.696,16.696,16.696h66.783 c9.22,0,16.696-7.475,16.696-16.696v-66.783C372.87,352.519,365.394,345.043,356.174,345.043z M339.478,411.826h-33.391v-33.391 h33.391V411.826z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  profileSettings: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <circle cx="12" cy="9" r="2" stroke="#2A353D" strokeWidth="1.5"></circle>{' '}
        <path
          d="M16 15C16 16.1046 16 17 12 17C8 17 8 16.1046 8 15C8 13.8954 9.79086 13 12 13C14.2091 13 16 13.8954 16 15Z"
          stroke="#2A353D"
          strokeWidth="1.5"
        ></path>{' '}
        <path
          d="M3 10.4167C3 7.21907 3 5.62028 3.37752 5.08241C3.75503 4.54454 5.25832 4.02996 8.26491 3.00079L8.83772 2.80472C10.405 2.26824 11.1886 2 12 2C12.8114 2 13.595 2.26824 15.1623 2.80472L15.7351 3.00079C18.7417 4.02996 20.245 4.54454 20.6225 5.08241C21 5.62028 21 7.21907 21 10.4167C21 10.8996 21 11.4234 21 11.9914C21 14.4963 20.1632 16.4284 19 17.9041M3.19284 14C4.05026 18.2984 7.57641 20.5129 9.89856 21.5273C10.62 21.8424 10.9807 22 12 22C13.0193 22 13.38 21.8424 14.1014 21.5273C14.6796 21.2747 15.3324 20.9478 16 20.5328"
          stroke="#2A353D"
          strokeWidth="1.5"
          strokeLinecap="round"
        ></path>{' '}
      </g>
    </svg>
  ),
  accountSettings: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.65 3L9.93163 3.53449L9.32754 5.54812L7.47651 4.55141L6.5906 4.68143L4.68141 6.59062L4.55139 7.47652L5.5481 9.32755L3.53449 9.93163L3 10.65V13.35L3.53449 14.0684L5.54811 14.6725L4.55142 16.5235L4.68144 17.4094L6.59063 19.3186L7.47653 19.4486L9.32754 18.4519L9.93163 20.4655L10.65 21H13.35L14.0684 20.4655L14.6725 18.4519L16.5235 19.4486L17.4094 19.3185L19.3186 17.4094L19.4486 16.5235L18.4519 14.6724L20.4655 14.0684L21 13.35V10.65L20.4655 9.93163L18.4519 9.32754L19.4486 7.47654L19.3186 6.59063L17.4094 4.68144L16.5235 4.55142L14.6725 5.54812L14.0684 3.53449L13.35 3H10.65ZM10.4692 6.96284L11.208 4.5H12.792L13.5308 6.96284L13.8753 7.0946C13.9654 7.12908 14.0543 7.16597 14.142 7.2052L14.4789 7.35598L16.7433 6.13668L17.8633 7.25671L16.644 9.52111L16.7948 9.85803C16.834 9.9457 16.8709 10.0346 16.9054 10.1247L17.0372 10.4692L19.5 11.208V12.792L17.0372 13.5308L16.9054 13.8753C16.8709 13.9654 16.834 14.0543 16.7948 14.1419L16.644 14.4789L17.8633 16.7433L16.7433 17.8633L14.4789 16.644L14.142 16.7948C14.0543 16.834 13.9654 16.8709 13.8753 16.9054L13.5308 17.0372L12.792 19.5H11.208L10.4692 17.0372L10.1247 16.9054C10.0346 16.8709 9.94569 16.834 9.85803 16.7948L9.52111 16.644L7.25671 17.8633L6.13668 16.7433L7.35597 14.4789L7.2052 14.142C7.16597 14.0543 7.12908 13.9654 7.0946 13.8753L6.96284 13.5308L4.5 12.792L4.5 11.208L6.96284 10.4692L7.0946 10.1247C7.12907 10.0346 7.16596 9.94571 7.20519 9.85805L7.35596 9.52113L6.13666 7.2567L7.25668 6.13667L9.5211 7.35598L9.85803 7.2052C9.9457 7.16597 10.0346 7.12908 10.1247 7.0946L10.4692 6.96284ZM14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12ZM15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92893 15.75 8.25 14.0711 8.25 12C8.25 9.92893 9.92893 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12Z"
          fill="#2A353D"
        ></path>{' '}
      </g>
    </svg>
  ),
  aboutUs: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M14.0295 15.7412C14.1628 16.2772 14.7052 16.6037 15.2412 16.4705C15.7772 16.3372 16.1037 15.7948 15.9705 15.2588L14.0295 15.7412ZM8.02953 15.2588C7.89631 15.7948 8.2228 16.3372 8.75878 16.4705C9.29476 16.6037 9.83725 16.2772 9.97047 15.7412L8.02953 15.2588ZM12 8.5C11.4477 8.5 11 8.94772 11 9.5C11 10.0523 11.4477 10.5 12 10.5V8.5ZM12.01 10.5C12.5623 10.5 13.01 10.0523 13.01 9.5C13.01 8.94772 12.5623 8.5 12.01 8.5V10.5ZM4.09202 19.782L4.54601 18.891L4.09202 19.782ZM3.21799 18.908L4.10899 18.454L3.21799 18.908ZM20.782 18.908L19.891 18.454L20.782 18.908ZM19.908 19.782L19.454 18.891L19.908 19.782ZM19.908 4.21799L19.454 5.10899L19.908 4.21799ZM20.782 5.09202L19.891 5.54601L20.782 5.09202ZM4.09202 4.21799L4.54601 5.10899L4.09202 4.21799ZM3.21799 5.09202L4.10899 5.54601L3.21799 5.09202ZM12 9.5V11.5C13.1046 11.5 14 10.6046 14 9.5H12ZM12 9.5H10C10 10.6046 10.8954 11.5 12 11.5V9.5ZM12 9.5V7.5C10.8954 7.5 10 8.39543 10 9.5H12ZM12 9.5H14C14 8.39543 13.1046 7.5 12 7.5V9.5ZM12 14.5C13.145 14.5 13.8839 15.1554 14.0295 15.7412L15.9705 15.2588C15.5488 13.5624 13.817 12.5 12 12.5V14.5ZM9.97047 15.7412C10.1161 15.1554 10.855 14.5 12 14.5V12.5C10.183 12.5 8.45119 13.5624 8.02953 15.2588L9.97047 15.7412ZM12 10.5H12.01V8.5H12V10.5ZM6.2 5H17.8V3H6.2V5ZM20 7.2V16.8H22V7.2H20ZM17.8 19H6.2V21H17.8V19ZM4 16.8V7.2H2V16.8H4ZM6.2 19C5.62345 19 5.25117 18.9992 4.96784 18.9761C4.69617 18.9539 4.59545 18.9162 4.54601 18.891L3.63803 20.673C4.01641 20.8658 4.40963 20.9371 4.80497 20.9694C5.18864 21.0008 5.65645 21 6.2 21V19ZM2 16.8C2 17.3436 1.99922 17.8114 2.03057 18.195C2.06287 18.5904 2.13419 18.9836 2.32698 19.362L4.10899 18.454C4.0838 18.4045 4.04612 18.3038 4.02393 18.0322C4.00078 17.7488 4 17.3766 4 16.8H2ZM4.54601 18.891C4.35785 18.7951 4.20487 18.6422 4.10899 18.454L2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673L4.54601 18.891ZM20 16.8C20 17.3766 19.9992 17.7488 19.9761 18.0322C19.9539 18.3038 19.9162 18.4045 19.891 18.454L21.673 19.362C21.8658 18.9836 21.9371 18.5904 21.9694 18.195C22.0008 17.8114 22 17.3436 22 16.8H20ZM17.8 21C18.3436 21 18.8114 21.0008 19.195 20.9694C19.5904 20.9371 19.9836 20.8658 20.362 20.673L19.454 18.891C19.4045 18.9162 19.3038 18.9539 19.0322 18.9761C18.7488 18.9992 18.3766 19 17.8 19V21ZM19.891 18.454C19.7951 18.6422 19.6422 18.7951 19.454 18.891L20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362L19.891 18.454ZM17.8 5C18.3766 5 18.7488 5.00078 19.0322 5.02393C19.3038 5.04612 19.4045 5.0838 19.454 5.10899L20.362 3.32698C19.9836 3.13419 19.5904 3.06287 19.195 3.03057C18.8114 2.99922 18.3436 3 17.8 3V5ZM22 7.2C22 6.65645 22.0008 6.18864 21.9694 5.80497C21.9371 5.40963 21.8658 5.01641 21.673 4.63803L19.891 5.54601C19.9162 5.59545 19.9539 5.69617 19.9761 5.96784C19.9992 6.25117 20 6.62345 20 7.2H22ZM19.454 5.10899C19.6422 5.20487 19.7951 5.35785 19.891 5.54601L21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698L19.454 5.10899ZM6.2 3C5.65645 3 5.18864 2.99922 4.80497 3.03057C4.40963 3.06287 4.01641 3.13419 3.63803 3.32698L4.54601 5.10899C4.59545 5.0838 4.69617 5.04612 4.96784 5.02393C5.25117 5.00078 5.62345 5 6.2 5V3ZM4 7.2C4 6.62345 4.00078 6.25117 4.02393 5.96784C4.04612 5.69617 4.0838 5.59545 4.10899 5.54601L2.32698 4.63803C2.13419 5.01641 2.06287 5.40963 2.03057 5.80497C1.99922 6.18864 2 6.65645 2 7.2H4ZM3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803L4.10899 5.54601C4.20487 5.35785 4.35785 5.20487 4.54601 5.10899L3.63803 3.32698Z"
          fill="#2A353D"
        ></path>{' '}
      </g>
    </svg>
  ),
  contactUs: (
    <svg
      width="20"
      height="20"
      version="1.1"
      id="XMLID_276_"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <g id="contact-us">
          {' '}
          <g>
            {' '}
            <path
              fill="#2A353D"
              d="M4,24v-5H0V0h23v19h-9.3L4,24z M2,17h4v3.7l7.3-3.7H21V2H2V17z"
            ></path>{' '}
          </g>{' '}
          <g>
            {' '}
            <rect fill="#2A353D" x="5" y="8" width="3" height="3"></rect>{' '}
          </g>{' '}
          <g>
            {' '}
            <rect fill="#2A353D" x="10" y="8" width="3" height="3"></rect>{' '}
          </g>{' '}
          <g>
            {' '}
            <rect fill="#2A353D" x="15" y="8" width="3" height="3"></rect>{' '}
          </g>{' '}
        </g>{' '}
      </g>
    </svg>
  ),
  terms: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 1024 1024"
      className="icon"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="#2A353D"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M182.52 146.2h585.14v402.28h73.15V73.06H109.38v877.71h402.28v-73.14H182.52z"
          fill="#2A353D"
        ></path>
        <path
          d="M255.67 219.34h438.86v73.14H255.67zM255.67 365.63h365.71v73.14H255.67zM255.67 511.91H475.1v73.14H255.67zM731.02 585.06c-100.99 0-182.86 81.87-182.86 182.86s81.87 182.86 182.86 182.86 182.86-81.87 182.86-182.86-81.87-182.86-182.86-182.86z m0 292.57c-60.5 0-109.71-49.22-109.71-109.71 0-60.5 49.22-109.71 109.71-109.71 60.5 0 109.71 49.22 109.71 109.71 0 60.49-49.22 109.71-109.71 109.71z"
          fill="#2A353D"
        ></path>
        <path
          d="M717.88 777.65l-42.55-38.13-36.61 40.86 84.02 75.27 102.98-118.47-41.39-36z"
          fill="#2A353D"
        ></path>
      </g>
    </svg>
  ),
  privacyPolicy: (
    <svg
      width="24"
      height="24"
      fill="#2A353D"
      viewBox="-2 0 19 19"
      xmlns="http://www.w3.org/2000/svg"
      className="cf-icon-svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fill="#2A353D"
          d="M14.443 4.445a1.615 1.615 0 0 1-1.613 1.614h-.506v8.396a1.615 1.615 0 0 1-1.613 1.613H2.17a1.613 1.613 0 1 1 0-3.227h.505V4.445A1.615 1.615 0 0 1 4.289 2.83h8.54a1.615 1.615 0 0 1 1.614 1.614zM2.17 14.96h7.007a1.612 1.612 0 0 1 0-1.01H2.172a.505.505 0 0 0 0 1.01zm9.045-10.515a1.62 1.62 0 0 1 .08-.505H4.29a.5.5 0 0 0-.31.107l-.002.001a.5.5 0 0 0-.193.397v8.396h6.337a.61.61 0 0 1 .6.467.632.632 0 0 1-.251.702.505.505 0 1 0 .746.445zm-.86 1.438h-5.76V6.99h5.76zm0 2.26h-5.76V9.25h5.76zm0 2.26h-5.76v1.108h5.76zm2.979-5.958a.506.506 0 0 0-.505-.505.496.496 0 0 0-.31.107h-.002a.501.501 0 0 0-.194.398v.505h.506a.506.506 0 0 0 .505-.505z"
        ></path>
      </g>
    </svg>
  ),
  blankCircle: (
    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.375 0.5C23.1157 0.5 27.6623 2.38325 31.0145 5.73547C34.3667 9.08768 36.25 13.6343 36.25 18.375C36.25 23.1157 34.3667 27.6623 31.0145 31.0145C27.6623 34.3667 23.1157 36.25 18.375 36.25C13.6343 36.25 9.08768 34.3667 5.73547 31.0145C2.38325 27.6623 0.5 23.1157 0.5 18.375C0.5 13.6343 2.38325 9.08768 5.73547 5.73547C9.08768 2.38325 13.6343 0.5 18.375 0.5Z"
        fill="white"
        stroke="#333333"
      />
    </svg>
  ),
  greenCircle: (
    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.375 0C23.2484 0 27.9221 1.93593 31.3681 5.38191C34.8141 8.82789 36.75 13.5016 36.75 18.375C36.75 23.2484 34.8141 27.9221 31.3681 31.3681C27.9221 34.8141 23.2484 36.75 18.375 36.75C13.5016 36.75 8.82789 34.8141 5.38191 31.3681C1.93593 27.9221 0 23.2484 0 18.375C0 13.5016 1.93593 8.82789 5.38191 5.38191C8.82789 1.93593 13.5016 0 18.375 0ZM16.086 22.0001L12.0041 17.9156C11.8578 17.7693 11.6841 17.6532 11.4929 17.574C11.3017 17.4948 11.0968 17.4541 10.8898 17.4541C10.6829 17.4541 10.4779 17.4948 10.2868 17.574C10.0956 17.6532 9.92183 17.7693 9.7755 17.9156C9.47997 18.2112 9.31394 18.612 9.31394 19.0299C9.31394 19.4479 9.47997 19.8487 9.7755 20.1442L14.973 25.3418C15.1189 25.4888 15.2925 25.6055 15.4838 25.6852C15.675 25.7649 15.8801 25.8059 16.0873 25.8059C16.2945 25.8059 16.4996 25.7649 16.6909 25.6852C16.8821 25.6055 17.0557 25.4888 17.2016 25.3418L27.9641 14.5766C28.1124 14.4309 28.2304 14.2573 28.3112 14.0657C28.3921 13.8742 28.4342 13.6685 28.4352 13.4606C28.4361 13.2527 28.3959 13.0467 28.3169 12.8544C28.2378 12.6621 28.1215 12.4873 27.9745 12.3402C27.8276 12.1931 27.653 12.0766 27.4608 11.9973C27.2686 11.918 27.0626 11.8776 26.8547 11.8783C26.6468 11.879 26.4411 11.9209 26.2495 12.0015C26.0578 12.0821 25.884 12.1999 25.7381 12.348L16.086 22.0001Z"
        fill="#0BB312"
      />
    </svg>
  ),
  greyCircle: (
    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.375 0C23.2484 0 27.9221 1.93593 31.3681 5.38191C34.8141 8.82789 36.75 13.5016 36.75 18.375C36.75 23.2484 34.8141 27.9221 31.3681 31.3681C27.9221 34.8141 23.2484 36.75 18.375 36.75C13.5016 36.75 8.82789 34.8141 5.38191 31.3681C1.93593 27.9221 0 23.2484 0 18.375C0 13.5016 1.93593 8.82789 5.38191 5.38191C8.82789 1.93593 13.5016 0 18.375 0ZM16.086 22.0001L12.0041 17.9156C11.8578 17.7693 11.6841 17.6532 11.4929 17.574C11.3017 17.4948 11.0968 17.4541 10.8898 17.4541C10.6829 17.4541 10.4779 17.4948 10.2868 17.574C10.0956 17.6532 9.92183 17.7693 9.7755 17.9156C9.47997 18.2112 9.31394 18.612 9.31394 19.0299C9.31394 19.4479 9.47997 19.8487 9.7755 20.1442L14.973 25.3418C15.1189 25.4888 15.2925 25.6055 15.4838 25.6852C15.675 25.7649 15.8801 25.8059 16.0873 25.8059C16.2945 25.8059 16.4996 25.7649 16.6909 25.6852C16.8821 25.6055 17.0557 25.4888 17.2016 25.3418L27.9641 14.5766C28.1124 14.4309 28.2304 14.2573 28.3112 14.0657C28.3921 13.8742 28.4342 13.6685 28.4352 13.4606C28.4361 13.2527 28.3959 13.0467 28.3169 12.8544C28.2378 12.6621 28.1215 12.4873 27.9745 12.3402C27.8276 12.1931 27.653 12.0766 27.4608 11.9973C27.2686 11.918 27.0626 11.8776 26.8547 11.8783C26.6468 11.879 26.4411 11.9209 26.2495 12.0015C26.0578 12.0821 25.884 12.1999 25.7381 12.348L16.086 22.0001Z"
        fill="#dedede"
      />
    </svg>
  ),
  redCircle: (
    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.375 0C23.2484 0 27.9221 1.93593 31.3681 5.38191C34.8141 8.82789 36.75 13.5016 36.75 18.375C36.75 23.2484 34.8141 27.9221 31.3681 31.3681C27.9221 34.8141 23.2484 36.75 18.375 36.75C13.5016 36.75 8.82789 34.8141 5.38191 31.3681C1.93593 27.9221 0 23.2484 0 18.375C0 13.5016 1.93593 8.82789 5.38191 5.38191C8.82789 1.93593 13.5016 0 18.375 0Z"
        fill="#E10606"
      />
      <path
        d="M25 12L12 25M12 12L25 25"
        stroke="#FEFEFE"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  globe: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M21 12C21 16.9706 16.9706 21 12 21M21 12C21 7.02944 16.9706 3 12 3M21 12C21 13.6569 16.9706 15 12 15C7.02944 15 3 13.6569 3 12M21 12C21 10.3431 16.9706 9 12 9C7.02944 9 3 10.3431 3 12M12 21C7.02944 21 3 16.9706 3 12M12 21C10.3431 21 9 16.9706 9 12C9 7.02944 10.3431 3 12 3M12 21C13.6569 21 15 16.9706 15 12C15 7.02944 13.6569 3 12 3M3 12C3 7.02944 7.02944 3 12 3"
          stroke="#545454"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{' '}
      </g>
    </svg>
  ),
  upload: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10V11H17C18.933 11 20.5 12.567 20.5 14.5C20.5 16.433 18.933 18 17 18H16C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20H17C20.0376 20 22.5 17.5376 22.5 14.5C22.5 11.7793 20.5245 9.51997 17.9296 9.07824C17.4862 6.20213 15.0003 4 12 4C8.99974 4 6.51381 6.20213 6.07036 9.07824C3.47551 9.51997 1.5 11.7793 1.5 14.5C1.5 17.5376 3.96243 20 7 20H8C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18H7C5.067 18 3.5 16.433 3.5 14.5C3.5 12.567 5.067 11 7 11H8V10ZM15.7071 13.2929L12.7071 10.2929C12.3166 9.90237 11.6834 9.90237 11.2929 10.2929L8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071L11 13.4142V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13.4142L14.2929 14.7071C14.6834 15.0976 15.3166 15.0976 15.7071 14.7071C16.0976 14.3166 16.0976 13.6834 15.7071 13.2929Z"
          fill="#000000"
        ></path>{' '}
      </g>
    </svg>
  ),
  downAngle: (
    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 1L6.29289 6.29289C6.62623 6.62623 6.79289 6.79289 7 6.79289C7.20711 6.79289 7.37377 6.62623 7.70711 6.29289L13 1"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  upAngle: (
    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 7L6.29289 1.70711C6.62623 1.37377 6.79289 1.20711 7 1.20711C7.20711 1.20711 7.37377 1.37377 7.70711 1.70711L13 7"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  cross: (
    <svg
      width="24"
      height="24"
      fill="#000000"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          fill="#000000"
          d="M18.8,16l5.5-5.5c0.8-0.8,0.8-2,0-2.8l0,0C24,7.3,23.5,7,23,7c-0.5,0-1,0.2-1.4,0.6L16,13.2l-5.5-5.5 c-0.8-0.8-2.1-0.8-2.8,0C7.3,8,7,8.5,7,9.1s0.2,1,0.6,1.4l5.5,5.5l-5.5,5.5C7.3,21.9,7,22.4,7,23c0,0.5,0.2,1,0.6,1.4 C8,24.8,8.5,25,9,25c0.5,0,1-0.2,1.4-0.6l5.5-5.5l5.5,5.5c0.8,0.8,2.1,0.8,2.8,0c0.8-0.8,0.8-2.1,0-2.8L18.8,16z"
        ></path>{' '}
      </g>
    </svg>
  ),
  dollar: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-1.565 -1.565 75 75"
      height="75"
      width="75"
      id="Family-Home--Streamline-Ultimate.svg"
    >
      <desc>Family Home Streamline Icon: https://streamlinehq.com</desc>
      <defs></defs>
      <title>family-home</title>
      <path
        d="M54.65114583333333 30.69747375a6.7378125 6.7378125 0 1 0 13.475625 0 6.7378125 6.7378125 0 1 0 -13.475625 0"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#dff9ff"
        strokeWidth="3.13"
      ></path>
      <path
        d="M61.388958333333335 40.426875a8.98375 8.98375 0 0 0 -8.98375 8.98375V56.897083333333335H56.897083333333335l1.4972916666666667 13.475625h5.989166666666667L65.88083333333333 56.897083333333335h4.491875v-7.486458333333333a8.98375 8.98375 0 0 0 -8.98375 -8.98375Z"
        fill="#9feaff"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.13"
      ></path>
      <path
        d="M3.7432291666666666 30.69747375a6.7378125 6.7378125 0 1 0 13.475625 0 6.7378125 6.7378125 0 1 0 -13.475625 0"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#dff9ff"
        strokeWidth="3.13"
      ></path>
      <path
        d="M10.481041666666666 40.426875a8.98375 8.98375 0 0 0 -8.98375 8.98375V56.897083333333335H5.989166666666667l1.4972916666666667 13.475625h5.989166666666667L14.972916666666666 56.897083333333335h4.491875v-7.486458333333333a8.98375 8.98375 0 0 0 -8.98375 -8.98375Z"
        fill="#9feaff"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.13"
      ></path>
      <path
        d="M27.699895833333333 24.7053125a8.235104166666666 8.235104166666666 0 1 0 16.470208333333332 0 8.235104166666666 8.235104166666666 0 1 0 -16.470208333333332 0"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#dff9ff"
        strokeWidth="3.13"
      ></path>
      <path
        d="M46.416041666666665 46.416041666666665a10.481041666666666 10.481041666666666 0 0 0 -20.962083333333332 0v8.98375h4.740425416666667l1.24874125 14.972916666666666h8.98375l1.24874125 -14.972916666666666H46.416041666666665Z"
        fill="#9feaff"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.13"
      ></path>
      <path
        d="M1.4972916666666667 19.464791666666667 34.54850791666667 1.8356795833333333a2.9945833333333334 2.9945833333333334 0 0 1 2.772984166666667 0L70.37270833333334 19.464791666666667"
        fill="none"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.13"
      ></path>
    </svg>
  ),
  sleep: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-1.565 -1.565 75 75"
      height="75"
      width="75"
      id="House-Modern--Streamline-Ultimate.svg"
    >
      <desc>House Modern Streamline Icon: https://streamlinehq.com</desc>
      <defs></defs>
      <title>house-modern</title>
      <path
        d="m31.443125000000002 10.34029625 0 18.108245416666666 -23.956666666666667 9.582666666666666 0 26.352333333333334 56.897083333333335 0 0 -33.596230416666664 -32.940416666666664 -20.447015z"
        fill="#dff9ff"
        strokeWidth="3.13"
      ></path>
      <path
        d="m31.443125000000002 28.448541666666667 -23.956666666666667 9.582666666666666v7.486458333333333L23.9866125 38.92958333333333a1.5122645833333335 1.5122645833333335 0 0 1 2.0752462499999997 1.4074541666666667v24.046504166666665h5.39025Z"
        fill="#9feaff"
        strokeWidth="3.13"
      ></path>
      <path
        d="m31.443125000000002 10.34029625 0 7.486458333333333 32.940416666666664 20.447015 0 -7.486458333333333 -32.940416666666664 -20.447015z"
        fill="#9feaff"
        strokeWidth="3.13"
      ></path>
      <path
        d="M38.92958333333333 52.405208333333334h17.9675s1.4972916666666667 0 1.4972916666666667 1.4972916666666667v8.98375s0 1.4972916666666667 -1.4972916666666667 1.4972916666666667h-17.9675s-1.4972916666666667 0 -1.4972916666666667 -1.4972916666666667v-8.98375s0 -1.4972916666666667 1.4972916666666667 -1.4972916666666667"
        fill="#9feaff"
        strokeWidth="3.13"
      ></path>
      <path
        d="M38.92958333333333 64.38354166666667h4.5457775l11.978333333333333 -11.978333333333333H38.92958333333333a1.4972916666666667 1.4972916666666667 0 0 0 -1.4972916666666667 1.4972916666666667v8.98375a1.4972916666666667 1.4972916666666667 0 0 0 1.4972916666666667 1.4972916666666667Z"
        fill="#dff9ff"
        strokeWidth="3.13"
      ></path>
      <path
        d="m1.4972916666666667 64.38354166666667 68.87541666666667 0"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        strokeWidth="3.13"
      ></path>
      <path
        d="m1.4972916666666667 40.426875 29.945833333333333 -11.978333333333333"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        strokeWidth="3.13"
      ></path>
      <path
        d="m7.486458333333333 38.088105416666664 0 26.29543625"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        strokeWidth="3.13"
      ></path>
      <path
        d="m26.95125 7.486458333333333 43.421458333333334 26.95125"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        strokeWidth="3.13"
      ></path>
      <path
        d="m64.38354166666667 30.787311250000002 0 33.596230416666664"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        strokeWidth="3.13"
      ></path>
      <path
        d="M55.399791666666665 25.175462083333333V14.972916666666666a1.4972916666666667 1.4972916666666667 0 0 1 1.4972916666666667 -1.4972916666666667h2.9945833333333334a1.4972916666666667 1.4972916666666667 0 0 1 1.4972916666666667 1.4972916666666667v13.89786125Z"
        fill="#9feaff"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.13"
      ></path>
      <path
        d="M56.897083333333335 64.38354166666667a1.4972916666666667 1.4972916666666667 0 0 0 1.4972916666666667 -1.4972916666666667v-8.98375a1.4972916666666667 1.4972916666666667 0 0 0 -1.4972916666666667 -1.4972916666666667h-17.9675a1.4972916666666667 1.4972916666666667 0 0 0 -1.4972916666666667 1.4972916666666667v8.98375a1.4972916666666667 1.4972916666666667 0 0 0 1.4972916666666667 1.4972916666666667"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        strokeWidth="3.13"
      ></path>
      <path
        d="m49.410625 52.405208333333334 0 11.978333333333333"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        strokeWidth="3.13"
      ></path>
      <path
        d="M40.429869583333335 34.43770833333333a4.491875 4.491875 0 1 0 8.98375 0 4.491875 4.491875 0 1 0 -8.98375 0"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#9feaff"
        strokeWidth="3.13"
      ></path>
      <path
        d="M14.972916666666666 49.410625h8.98375s1.4972916666666667 0 1.4972916666666667 1.4972916666666667v11.978333333333333s0 1.4972916666666667 -1.4972916666666667 1.4972916666666667H14.972916666666666s-1.4972916666666667 0 -1.4972916666666667 -1.4972916666666667v-11.978333333333333s0 -1.4972916666666667 1.4972916666666667 -1.4972916666666667"
        fill="#9feaff"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.13"
      ></path>
      <path
        d="m31.443125000000002 10.34029625 0 54.04324541666667"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        strokeWidth="3.13"
      ></path>
    </svg>
  ),
  heartHand: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-1.565 -1.565 75 75"
      height="75"
      width="75"
      id="Products-Give-Gift-1--Streamline-Ultimate.svg"
    >
      <desc>Products Give Gift 1 Streamline Icon: https://streamlinehq.com</desc>
      <defs></defs>
      <path
        d="M2.9945833333333334 42.732704166666664h8.98375s1.4972916666666667 0 1.4972916666666667 1.4972916666666667v20.962083333333332s0 1.4972916666666667 -1.4972916666666667 1.4972916666666667H2.9945833333333334s-1.4972916666666667 0 -1.4972916666666667 -1.4972916666666667v-20.962083333333332s0 -1.4972916666666667 1.4972916666666667 -1.4972916666666667"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#9feaff"
        strokeWidth="3.13"
      ></path>
      <path
        d="M69.53422499999999 55.729195833333335c-34.198141666666665 17.278745833333332 -24.5256375 16.9792875 -56.0586 6.4683v-16.470208333333332h8.98375a19.76425 19.76425 0 0 1 13.475625 5.989166666666667h8.98375a2.9945833333333334 2.9945833333333334 0 0 1 2.9945833333333334 2.9945833333333334 3.1053829166666667 3.1053829166666667 0 0 1 -0.9283208333333334 2.1860458333333335l15.571833333333334 -5.180629166666667a7.486458333333333 7.486458333333333 0 0 1 7.2468916666666665 1.4374 1.5481995833333333 1.5481995833333333 0 0 1 -0.2695125 2.5753416666666666Z"
        fill="#dff9ff"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.13"
      ></path>
      <path
        d="M28.448541666666667 57.705620833333334H44.91875a3.1143666666666667 3.1143666666666667 0 0 0 2.0662624999999997 -0.8085375"
        fill="none"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.13"
      ></path>
      <path
        d="M31.443125000000002 21.773615416666665v16.470208333333332a1.4972916666666667 1.4972916666666667 0 0 0 1.4972916666666667 1.4972916666666667h26.95125a1.4972916666666667 1.4972916666666667 0 0 0 1.4972916666666667 -1.4972916666666667v-16.470208333333332Z"
        fill="#dff9ff"
        strokeWidth="3.13"
      ></path>
      <path
        d="M31.443125000000002 21.773615416666665h29.945833333333333v6.453327083333333h-29.945833333333333Z"
        fill="#9feaff"
        strokeWidth="3.13"
      ></path>
      <path
        d="M31.443125000000002 21.773615416666665v16.470208333333332a1.4972916666666667 1.4972916666666667 0 0 0 1.4972916666666667 1.4972916666666667h26.95125a1.4972916666666667 1.4972916666666667 0 0 0 1.4972916666666667 -1.4972916666666667v-16.470208333333332"
        fill="none"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.13"
      ></path>
      <path
        d="M29.945833333333333 12.789865416666666h32.940416666666664s1.4972916666666667 0 1.4972916666666667 1.4972916666666667v5.989166666666667s0 1.4972916666666667 -1.4972916666666667 1.4972916666666667H29.945833333333333s-1.4972916666666667 0 -1.4972916666666667 -1.4972916666666667v-5.989166666666667s0 -1.4972916666666667 1.4972916666666667 -1.4972916666666667"
        fill="#dff9ff"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.13"
      ></path>
      <path
        d="m46.416041666666665 39.741115416666666 0 -26.95125"
        fill="none"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.13"
      ></path>
      <path
        d="M54.932636666666674 8.555524583333334a23.711110833333333 23.711110833333333 0 0 1 -8.468681666666667 4.234340833333333 23.633251666666666 23.633251666666666 0 0 1 4.234340833333333 -8.468681666666667c2.63223875 -2.63223875 4.12354125 -2.2249754166666666 5.3004125 -1.0600825s1.5661670833333334 2.6621845833333335 -1.0660716666666665 5.2944233333333335Z"
        fill="none"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.13"
      ></path>
      <path
        d="M37.89944666666667 8.555524583333334a23.711110833333333 23.711110833333333 0 0 0 8.468681666666667 4.234340833333333 23.633251666666666 23.633251666666666 0 0 0 -4.234340833333333 -8.468681666666667C39.501548750000005 1.688945 38.01024625 2.0962083333333332 36.833375000000004 3.26110125s-1.5661670833333334 2.6621845833333335 1.0660716666666665 5.2944233333333335Z"
        fill="none"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.13"
      ></path>
    </svg>
  ),
  rightAngle: (
    <svg fill="none" width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="19.6875" fill="white" stroke="none" strokeWidth="0.625" />
      <path d="M17.5 13.75L23.75 20L17.5 26.25" stroke="#3D3D3D" strokeWidth="1.5" />
    </svg>
  ),
};

const Icons = ({ name }) => {
  return icons[name];
};

export default Icons;
